var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var d, c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc); else for (var i = decorators.length - 1; i >= 0; i--) (d = decorators[i]) && (r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r);
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}, __metadata = this && this.__metadata || function(k, v) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(k, v);
}, __param = this && this.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};

import { inject, injectable, named } from "../common/inversify-lite";

import { ContributionProvider } from "../common/contribution-provider";

import { SyncHook } from "../tapable";

import { EnvContribution } from "../constants";

import { Generator } from "../common/generator";

const defaultEnv = "browser";

let DefaultGlobal = class {
    get env() {
        return this._env;
    }
    get devicePixelRatio() {
        return this._env || this.setEnv("browser"), this.envContribution.getDevicePixelRatio();
    }
    get supportEvent() {
        return this._env || this.setEnv("browser"), this.envContribution.supportEvent;
    }
    set supportEvent(support) {
        this._env || this.setEnv("browser"), this.envContribution.supportEvent = support;
    }
    get supportsTouchEvents() {
        return this._env || this.setEnv("browser"), this.envContribution.supportsTouchEvents;
    }
    set supportsTouchEvents(support) {
        this._env || this.setEnv("browser"), this.envContribution.supportsTouchEvents = support;
    }
    get supportsPointerEvents() {
        return this._env || this.setEnv("browser"), this.envContribution.supportsPointerEvents;
    }
    set supportsPointerEvents(support) {
        this._env || this.setEnv("browser"), this.envContribution.supportsPointerEvents = support;
    }
    get supportsMouseEvents() {
        return this._env || this.setEnv("browser"), this.envContribution.supportsMouseEvents;
    }
    set supportsMouseEvents(support) {
        this._env || this.setEnv("browser"), this.envContribution.supportsMouseEvents = support;
    }
    get applyStyles() {
        return this._env || this.setEnv("browser"), this.envContribution.applyStyles;
    }
    set applyStyles(support) {
        this._env || this.setEnv("browser"), this.envContribution.applyStyles = support;
    }
    constructor(contributions) {
        this.contributions = contributions, this.id = Generator.GenAutoIncrementId(), this.hooks = {
            onSetEnv: new SyncHook([ "lastEnv", "env", "global" ])
        }, this.measureTextMethod = "native", this.optimizeVisible = !1;
    }
    bindContribution(params) {
        const promiseArr = [];
        if (this.contributions.getContributions().forEach((contribution => {
            const data = contribution.configure(this, params);
            data && data.then && promiseArr.push(data);
        })), promiseArr.length) return Promise.all(promiseArr);
    }
    getDynamicCanvasCount() {
        return this._env || this.setEnv("browser"), this.envContribution.getDynamicCanvasCount();
    }
    getStaticCanvasCount() {
        return this._env || this.setEnv("browser"), this.envContribution.getStaticCanvasCount();
    }
    setEnv(env, params) {
        if (params && !0 === params.force || this._env !== env) return this.deactiveCurrentEnv(), 
        this.activeEnv(env, params);
    }
    deactiveCurrentEnv() {
        this.envContribution && this.envContribution.release();
    }
    activeEnv(env, params) {
        const lastEnv = this._env;
        this._env = env;
        const data = this.bindContribution(params);
        if (data && data.then) return data.then((() => {
            this.envParams = params, this.hooks.onSetEnv.call(lastEnv, env, this);
        }));
        this.envParams = params, this.hooks.onSetEnv.call(lastEnv, env, this);
    }
    setActiveEnvContribution(contribution) {
        this.envContribution = contribution;
    }
    createCanvas(params) {
        return this._env || this.setEnv("browser"), this.envContribution.createCanvas(params);
    }
    createOffscreenCanvas(params) {
        return this._env || this.setEnv("browser"), this.envContribution.createOffscreenCanvas(params);
    }
    releaseCanvas(canvas) {
        return this._env || this.setEnv("browser"), this.envContribution.releaseCanvas(canvas);
    }
    addEventListener(type, listener, options) {
        return this._env || this.setEnv("browser"), this.envContribution.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        return this._env || this.setEnv("browser"), this.envContribution.removeEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._env || this.setEnv("browser"), this.envContribution.dispatchEvent(event);
    }
    getRequestAnimationFrame() {
        return this._env || this.setEnv("browser"), this.envContribution.getRequestAnimationFrame();
    }
    getCancelAnimationFrame() {
        return this._env || this.setEnv("browser"), this.envContribution.getCancelAnimationFrame();
    }
    getElementById(str) {
        return this._env || this.setEnv("browser"), this.envContribution.getElementById ? this.envContribution.getElementById(str) : null;
    }
    getRootElement() {
        return this._env || this.setEnv("browser"), this.envContribution.getRootElement ? this.envContribution.getRootElement() : null;
    }
    getDocument() {
        return this._env || this.setEnv("browser"), this.envContribution.getDocument ? this.envContribution.getDocument() : null;
    }
    mapToCanvasPoint(event, domElement) {
        return this._env || this.setEnv("browser"), this.envContribution.mapToCanvasPoint ? this.envContribution.mapToCanvasPoint(event, domElement) : null;
    }
    loadImage(url) {
        return this._env || this.setEnv("browser"), this.envContribution.loadImage(url);
    }
    loadSvg(str) {
        return this._env || this.setEnv("browser"), this.envContribution.loadSvg(str);
    }
    loadJson(url) {
        return this._env || this.setEnv("browser"), this.envContribution.loadJson(url);
    }
    loadArrayBuffer(url) {
        return this._env || this.setEnv("browser"), this.envContribution.loadArrayBuffer(url);
    }
    loadBlob(url) {
        return this._env || this.setEnv("browser"), this.envContribution.loadBlob(url);
    }
    isChrome() {
        return null != this._isChrome || (this._env || this.setEnv("browser"), this._isChrome = "browser" === this._env && navigator.userAgent.indexOf("Chrome") > -1), 
        this._isChrome;
    }
    isSafari() {
        return null != this._isSafari || (this._env || this.setEnv("browser"), this._isSafari = "browser" === this._env && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)), 
        this._isSafari;
    }
    getNativeAABBBounds(dom) {
        return this._env || this.setEnv("browser"), this.envContribution.getNativeAABBBounds(dom);
    }
    removeDom(dom) {
        return this._env || this.setEnv("browser"), this.envContribution.removeDom(dom);
    }
    createDom(params) {
        return this._env || this.setEnv("browser"), this.envContribution.createDom(params);
    }
    updateDom(dom, params) {
        return this._env || this.setEnv("browser"), this.envContribution.updateDom(dom, params);
    }
    getElementTop(dom, baseWindow = !1) {
        return this._env || this.setEnv("browser"), this.envContribution.getElementTop(dom, baseWindow);
    }
    getElementLeft(dom, baseWindow = !1) {
        return this._env || this.setEnv("browser"), this.envContribution.getElementLeft(dom, baseWindow);
    }
    getElementTopLeft(dom, baseWindow = !1) {
        return this._env || this.setEnv("browser"), this.envContribution.getElementTopLeft(dom, baseWindow);
    }
};

DefaultGlobal = __decorate([ injectable(), __param(0, inject(ContributionProvider)), __param(0, named(EnvContribution)), __metadata("design:paramtypes", [ Object ]) ], DefaultGlobal);

export { DefaultGlobal };
//# sourceMappingURL=global.js.map
